(() => {
  const initialize = (root) => {
    if (!root || root.dataset.araBrandHeaderReady === 'true') return;

    root.dataset.araBrandHeaderReady = 'true';

    const openButton = root.querySelector('[data-ara-drawer-open]');
    const drawer = root.querySelector('[data-ara-drawer]');
    const panel = drawer?.querySelector('.ara-brand-drawer__panel');
    const closeButtons = drawer
      ? Array.from(drawer.querySelectorAll('[data-ara-drawer-close]'))
      : [];
    const drawerLinks = drawer
      ? Array.from(drawer.querySelectorAll('[data-ara-drawer-link]'))
      : [];

    let lastFocused = null;

    const getFocusable = () => {
      if (!panel) return [];

      return Array.from(
        panel.querySelectorAll(
          'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled])'
        )
      ).filter((element) => element.offsetParent !== null);
    };

    const closeDrawer = (restoreFocus = true) => {
      if (!drawer || !drawer.classList.contains('is-open')) return;

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButton?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ara-brand-drawer-open');

      drawer.querySelectorAll('details[open]').forEach((details) => {
        details.removeAttribute('open');
      });

      if (restoreFocus && lastFocused instanceof HTMLElement) {
        window.setTimeout(() => lastFocused.focus(), 40);
      }
    };

    const openDrawer = () => {
      if (!drawer) return;

      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openButton?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ara-brand-drawer-open');

      window.requestAnimationFrame(() => {
        const firstFocusable = getFocusable()[0];
        firstFocusable?.focus();
      });
    };

    openButton?.addEventListener('click', () => {
      if (drawer?.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closeDrawer());
    });

    drawerLinks.forEach((link) => {
      link.addEventListener('click', () => closeDrawer(false));
    });

    document.addEventListener('keydown', (event) => {
      if (!drawer?.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getFocusable();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener(
      'resize',
      () => {
        if (window.innerWidth >= 990) closeDrawer(false);
      },
      { passive: true }
    );

    root.querySelectorAll('[data-ara-desktop-menu]').forEach((details) => {
      let closeTimer = null;

      const open = () => {
        if (window.innerWidth < 990) return;
        window.clearTimeout(closeTimer);

        root.querySelectorAll('[data-ara-desktop-menu][open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });

        details.setAttribute('open', '');
      };

      const close = () => {
        if (window.innerWidth < 990) return;
        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
        }, 100);
      };

      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', close);
      details.addEventListener('focusin', open);
      details.addEventListener('focusout', (event) => {
        if (!details.contains(event.relatedTarget)) close();
      });
    });

    document.addEventListener('click', (event) => {
      if (root.contains(event.target)) return;

      root.querySelectorAll('[data-ara-desktop-menu][open]').forEach((details) => {
        details.removeAttribute('open');
      });
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-ara-brand-header]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), {
      once: true,
    });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();